import { render, staticRenderFns } from "./domainGroupUpdate.vue?vue&type=template&id=44c687a8&"
import script from "./domainGroupUpdate.vue?vue&type=script&lang=js&"
export * from "./domainGroupUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports